import React from 'react';

const Pokeball = ({ ...props }) => (
  <svg 
    viewBox="0 0 100 100" 
    width="1em" 
    height="1em" 
    fill="currentColor" 
    {...props}
  >
    {/* Outer circle border */}
    <circle 
      cx="50" 
      cy="50" 
      r="48" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2"
    />
    
    {/* Top half (red) */}
    <path 
      d="M 2 50 A 48 48 0 0 1 98 50 L 68 50 A 18 18 0 0 0 32 50 Z" 
      fill="#DC143C"
    />
    
    {/* Bottom half (white) */}
    <path 
      d="M 2 50 A 48 48 0 0 0 98 50 L 68 50 A 18 18 0 0 1 32 50 Z" 
      fill="white"
    />
    
    {/* Black center line */}
    <rect 
      x="0" 
      y="46" 
      width="32" 
      height="8" 
      fill="currentColor"
    />
    <rect 
      x="68" 
      y="46" 
      width="32" 
      height="8" 
      fill="currentColor"
    />
    
    {/* Center button (white circle with border) */}
    <circle 
      cx="50" 
      cy="50" 
      r="10" 
      fill="white" 
      stroke="currentColor" 
      strokeWidth="2"
    />
    
    {/* Inner button detail */}
    <circle 
      cx="50" 
      cy="50" 
      r="6" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="1"
      opacity="0.3"
    />
  </svg>
);

export default Pokeball;